/* eslint-disable */
import React, { useReducer, useEffect } from 'react';
import { Provider } from './AlertFiltersContext';
import { AlertHeader, AlertContent, AlertCTA, AlertWarning, TalentMatchWidget } from './components';
import { mzTrack, createFacet } from './helpers';
import { getClassNames } from 'module-tsl-ui-jobs-common';
import { reducer } from './AlertFiltersReducer';
import { Error } from 'module-tsl-ui-elements';

export const AlertFilters = (props) => {
  const setSelectedFacets = (searchDetails, i18n) => {
    return createFacet(searchDetails, i18n);
  };

  const initialState = {
    isDeleted: false,
    isCanceled: false,
    isError: '',
    hasJobs: false,
    frequency: 'daily',
    sort: 'date',
    enableDistance: false,
    prefix: 'tds-alert',
    editing: false,
    isSaved: false,
    ...props,
    facets: (props.searchDetails && setSelectedFacets(props.searchDetails, props.i18n)) || [],
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const { id, editing, isDeleted, isCanceled, prefix, isSaved, isError, hasJobs, fromSearch } = state;

  const className = getClassNames({
    [prefix]: true,
    'tds-alert--edit': editing && !hasJobs,
    'tds-alert--save': hasJobs,
  });

  return (
    <Provider state={state} dispatch={dispatch}>
      {isCanceled && !id && (
        <AlertWarning
          action="cancel"
          item="isCanceled"
          message="Are you sure you want to leave without creating a job alert?"
        />
      )}

      {!isCanceled && !isDeleted && !isSaved && (
        <div className={className}>
          {!fromSearch && <AlertHeader />}
          <AlertContent />
          {isError === 'duplicate' && <Error error="You've already saved this alert" />}
          {isError === 'error' && <Error error="Technical issue please try again later" />}
          {editing && <AlertCTA />}
        </div>
      )}

      {isDeleted && (
        <AlertWarning action="delete" item="isDeleted" message="Are you sure you want your job alert to be deleted?" />
      )}

      {isSaved && <TalentMatchWidget />}
    </Provider>
  );
};
